export default __webpack_public_path__ + "static/media/active loan-01.98d21579.svg";